<template>
    <section
        class="share-bar"
    >
        <v-btn
            class="share-bar-btn"
            :icon="fab"
            variant="text"
            :disabled="!messagesLoaded"
            :title="messagesLoaded ? t('async.common.share.on_facabook') : ''"
            @click="shareLinkFn({plattform: socialMedia.FACEBOOK,})"
        >
            <v-icon>
                bs:$vuetify.icons.mdiFacebook
            </v-icon>
        </v-btn>
        <v-btn
            class="share-bar-btn"
            :icon="fab"
            variant="text"
            :disabled="!messagesLoaded"
            :title="messagesLoaded ? t('async.common.share.on_twitter') : ''"
            @click="shareLinkFn({plattform: socialMedia.TWITTER,})"
        >
            <v-icon>
                bs:$vuetify.icons.mdiTwitter
            </v-icon>
        </v-btn>
        <v-btn
            class="d-md-none d-inline-flex share-bar-btn"
            :icon="fab"
            variant="text"
            :disabled="!messagesLoaded"
            :title="messagesLoaded ? t('async.common.share.on_whatsapp') : ''"
            @click="shareLinkFn({plattform: socialMedia.WHATSAPP,})"
        >
            <v-icon>
                bs:$vuetify.icons.mdiWhatsapp
            </v-icon>
        </v-btn>
        <v-btn
            class="share-bar-btn share-bar-btn--clipboard"
            :icon="fab"
            variant="text"
            :disabled="!messagesLoaded"
            :title="messagesLoaded ? t('async.common.share.copy_to_clipboard') : ''"
            @click.stop="shareLinkToClipboard({idPrefix,})"
        >
            <v-icon>
                bs:$vuetify.icons.mdiContentCopy
            </v-icon>
        </v-btn>
        <input
            :id="`${idPrefix}_${$.uid}`"
            type="text"
            class="d-sr-only"
            :value="shareLink"
            aria-hidden="true"
            tabindex="-1"
        >
    </section>
</template>

<script>
import {useSnackbarStore,} from '@/assets/js/src/modules/snackbar/_pinia/snackbar'
import {useTranslation,} from "@/assets/js/src/util/composables/useTranslation"
const FACEBOOK = 1
const WHATSAPP = 2
const TWITTER = 3
const CLIPBOARD = 4
    
export default {
    name: 'ButtonGroupShare',
    props: {
        socialMedia: {
            type: Object,
            default: () => ({
                FACEBOOK,
                WHATSAPP,
                TWITTER,
                CLIPBOARD,
            }),
        },
        shareLink: {
            type: String,
            default: 'https://www.bibleserver.com',
        },
        messagesLoaded: {
            type: Boolean,
            default: false,
        },
        fab: {
            type: Boolean,
            default: true,
        },
        idPrefix: {
            type: String,
            default: 'shareLinkInput',
        },
    },
    setup () {
        return {
            ...useTranslation(),
        }
    },
    methods: {
        async shareLinkFn ({plattform,}) {
            if(!this.messagesLoaded) {
                return false
            }
            // Den Teilen-Link entsprechend der Share-Platform aufbereiten
            let rawShortLink = this.shareLink
            let shortLink = ''
            let name = ''
            switch (plattform) {
            case FACEBOOK:
                shortLink = `https://www.facebook.com/share.php?u=${rawShortLink}`
                name = 'Facebook'
                break
            case TWITTER:
                shortLink = `https://twitter.com/intent/tweet?text=${this.t('async.common.share.text', {shortLink: rawShortLink,})}`
                name = 'Twitter'
                break
            case WHATSAPP:
                shortLink = `https://api.whatsapp.com/send?phone=&text=${this.t('async.common.share.text', {shortLink: rawShortLink,})}`
                name = 'Whatsapp'
                break
            }
            if ([ FACEBOOK, TWITTER, WHATSAPP, ].includes(plattform)) {
                let newWin = window.open(shortLink, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
                if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                    let snackbarStore = useSnackbarStore(this.$pinia)
                    snackbarStore.showMessage({
                        message: this.t('async.common.popup_blocker_notice'),
                        type: 'error',
                    })
                }
                this.$bsa && this.$bsa.event({
                    eventCategory: 'share',
                    eventAction: name,
                    eventLabel: rawShortLink,
                    eventValue: !newWin || newWin.closed || typeof newWin.closed === 'undefined' ? 0 : 1,
                })
            }

            return false
        },
        shareLinkToClipboard ({idPrefix,}) {
            // Den Teilen-Link entsprechend der Share-Platform aufbereiten
            let element = document.getElementById(`${idPrefix}_${this.$.uid}`)
            let isReadOnly = element.hasAttribute('readonly')

            if (!isReadOnly) {
                element.setAttribute('readonly', '')
            }
            element.select()
            element.setSelectionRange(0, element.value.length)

            let succeeded

            try {
                succeeded = document.execCommand('copy')
            } catch (err) {
                succeeded = false
            }

            if (isReadOnly) {
                element.removeAttribute('readonly')
            }

            let snackbarStore = useSnackbarStore(this.$pinia)
            snackbarStore.showMessage({
                message: succeeded ? this.t('async.common.share.confirm_copy') : this.t('async.common.standard_error'),
                type: succeeded ? 'success' : 'error',
            })

            succeeded && this.$bsa && this.$bsa.event({
                eventCategory: 'share',
                eventAction: 'clipboard',
                eventLabel: element.value,
                eventValue: 1,
            })

            return false
        },
    },
}

</script>

<style lang="scss">
    @use '@/assets/js/src/style/elements/btnAction';

    .bs-app .share-bar {
        @include btnAction.btnAction;

        &-btn {
            margin-right: 2px!important;
            margin-left: 2px!important;
        }
    }
</style>
